import React from "react";
import "./index.css";
import QHRSETSidebar from "../qhrsetSidebar";
import { Outlet } from "react-router-dom"; // Removed unused imports
import QSETHeader from "../qsetheader";
import Breadcrumbs from "../breadcrumb/breadcrumbs";

function QSETTransactions({ hideSidebar, hideHeaderContent = false }) {
  return (
    <div className="">
      <QSETHeader hideHeaderContent={hideHeaderContent} />
      <div className="row qsetrowdesign">
        {!hideSidebar && (
          <div className="qsetcol-3">
            <QHRSETSidebar />
          </div>
        )}

        <div
          className={hideSidebar ? "qsetfullWidth qsetbodyPart" : "qsetcol-9"}
        >
          {!hideSidebar && (
            <div className="qset-breadcrumbs-override">
              <Breadcrumbs />
            </div>
          )}
          <div>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default QSETTransactions;
